/**
 * Коды вознаграждения → ключи i18n (§6 CLAUDE.md).
 *
 * Backend присылает коды, тексты собирает интерфейс. Сырой `PRICE_DIFFERS` на
 * экране — утечка внутренностей, поэтому ключ строится здесь, а перевод обязан
 * существовать во всех трёх локалях.
 */

import type { SuccessFeeDisputeReason, SuccessFeeModel, SuccessFeeStatus } from './types';

export function feeModelKey(model: SuccessFeeModel): string {
  return `successFee.model.${model}`;
}

export function feeStatusKey(status: SuccessFeeStatus): string {
  return `successFee.status.${status}`;
}

export function feeBenefitKey(code: string): string {
  return `successFee.benefit.${code}`;
}

export function disputeReasonKey(reason: SuccessFeeDisputeReason): string {
  return `successFee.disputeReason.${reason}`;
}
